import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export const MarketingTagType = {
  TEMPORAL: "temporal",
  CONTENT: "content",
  PROBLEM: "problem",
  SOLUTION: "solution",
} as const;

export type MarketingTagTypeValue = (typeof MarketingTagType)[keyof typeof MarketingTagType];

export class MarketingTag extends HasProjectMixin(Model) {

  declare id: number;
  declare board: number;
  declare label: string;
  declare type: MarketingTagTypeValue;
  declare description: string | null;
  declare isFolderEligible: boolean;

  static get $name() {
    return "MarketingTag";
  }

  static get fields() {
    return [
      "id",
      "board",
      "label",
      "type",
      "description",
      { name: "isFolderEligible", dataSource: "is_folder_eligible", type: "boolean", defaultValue: false },
    ];
  }

  get isTemporal(): boolean {
    return this.type === MarketingTagType.TEMPORAL;
  }
}

// @ts-expect-error - exposeProperties is internal method
MarketingTag.exposeProperties();
